<template>
  <section class="hero">
    <div class="content">
      <div class="description">
        <h1>Realistischer Schätzwert für deine Immobilie</h1>
        <p>Kostenlose Online-Bewertung in 3 Min</p>
      </div>
      <single-line-address
        class="address-entry"
        floatingButton="Online-Preisrechner"
        target="_blank"
        m-tracking="sea_estimate_landing_online_price_calculator_estimate_step1"
        :layout="isMobile ? 'vertical' : 'horizontal'"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.hero {
  background: linear-gradient(
      7.56deg,
      rgba(0, 0, 0, 0) 21.35%,
      rgba(0, 0, 0, 0.49) 56.16%,
      rgba(0, 0, 0, 0.1) 91.56%
    ),
    url('/public/assets/images/hero_small.jpg');
  background-size: cover;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 3.5rem 1rem 2rem;

  .content {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 64rem;
    width: 100%;

    .description {
      h1 {
        font-size: 1.6875rem;
        font-weight: 700;
        color: var(--color-white);
        text-shadow: 0 15px 30px rgba(50, 50, 93, 0.08), 0 5px 5px rgba(0, 0, 0, 0.05),
          0 -3px 8px rgba(0, 0, 0, 0.04);
        margin: 0 0 0.5rem 0;
      }
      p {
        font-size: 1.125rem;
        text-shadow: 0 15px 30px rgba(50, 50, 93, 0.08), 0 5px 5px rgba(0, 0, 0, 0.05),
          0 -3px 8px rgba(0, 0, 0, 0.04);
        color: var(--color-grey-100);
        margin: 0 0 2.5rem 0;
      }
    }
  }

  .address-entry {
    max-width: 47.5rem;
  }
}

.is-desktop .hero {
  background-image: url('/public/assets/images/hero_large.jpg');
  background-position: top right;
  padding: 7.5rem 3.5rem 3.5rem;

  .content {
    height: 368px;

    .description {
      max-width: 31.25rem;

      h1 {
        font-size: 2.125rem;
      }

      p {
        font-size: 1.1875rem;
        margin-bottom: 3.5rem;
      }
    }
  }
}

@media (max-width: 767px) {
  .content {
    height: 295px;
  }
}

@media (max-width: 602px) {
  .content {
    height: 323px;
  }
}

@media (max-width: 350px) {
  .content {
    height: 371px;
  }
}
</style>

<script>
import SingleLineAddress from './SingleLineAddress.vue';

export default {
  name: 'HeroContainer',
  components: {
    SingleLineAddress,
  },
  inject: ['isMobile'],
};
</script>
